// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","social":"Footer_social__MfQNF","list":"Footer_list__pNU8w","item":"Footer_item__F4ny-"};